import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPaginationEllipsisProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePaginationContext
} from "../../context";
import {
    PaginationEllipsisIcon
} from "../../icons";

const PaginationEllipsis: FC<IPaginationEllipsisProps> = ({
    customTheme: customThemeProp,
    style
}) => {
    const context = usePaginationContext();

    const {
        controlHeights,
        iconSizes,
        colors
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        size: context.size,
        controlHeights
    });

    return <View
        importantForAccessibility="no-hide-descendants"
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    >
        <PaginationEllipsisIcon
            customColor={colors.content.icon.low}
            size={iconSizes[context.size]}
            color="low"
        />
    </View>;
};
export default PaginationEllipsis;
